import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import type { PapiNetworkbarStrip } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import Surface from '@wix/da-ds/pkg/Surface';
import TitledStrip, { cardWidth } from '../../_partials/TitledStrip';
import SellerCard from '../../_partials/SellerCard';
import { useMeasuredMobileSwipeCookie } from '../useMeasuredMobileSwipeCookie';
import s from './FeaturedShopsStrip.scss';

interface Props {
  strip: PapiNetworkbarStrip;
  className?: string;
}

const FeaturedShopsStrip: React.FC<Props> = ({ strip, className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { ref, dimensions } = useMeasuredMobileSwipeCookie();

  return (
    <Surface
      elevation={ThemeSurface.PRIMARY}
      className={c(s['root'], className)}
    >
      <TitledStrip
        title={t('shopPage.sellYourArt.strips.featuredShops.heading')}
        description={t('shopPage.sellYourArt.strips.featuredShops.description')}
        className={s['content']}
      >
        {strip.users &&
          strip.users.map(user => (
            <div
              key={user.userId}
              className={s['center-for-mobile-slider']}
              ref={ref}
            >
              <SellerCard
                user={user}
                width={isMobile ? dimensions.width : cardWidth}
                className={className}
                withShopCta
              />
            </div>
          ))}
      </TitledStrip>
    </Surface>
  );
};

FeaturedShopsStrip.displayName = 'FeaturedShopsStrip';

export default FeaturedShopsStrip;
